import React from 'react'
import { GeolocationContainer, GeolocationIcon } from './GeolocationStyles'
import { useTranslation } from 'react-i18next'
import ControlsTooltipWrapper from '../ControlsTooltipWrapper'

const Geolocation = ({
  onClick = () => { }
}) => {
  const { t } = useTranslation()

  return (
    <GeolocationContainer>
      <ControlsTooltipWrapper
        title={t('cartography.maps.controls.geolocation')}
        arrow
        placement='right'
      >
        <GeolocationIcon
          onClick={onClick}
        >
          <i
            className={`fa-solid fa-circle-location-arrow`}
            style={{ fontSize: '16px' }}
          />
        </GeolocationIcon>
      </ControlsTooltipWrapper>
    </GeolocationContainer>
  )
}

export default Geolocation